module.exports = __webpack_public_path__ + "img/face-grin-squint-tears.44295af2.svg";